import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {SiteSearchModel} from "../site-search.model";
import {SiteEntityModel} from "../site-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-site-search-page",
    templateUrl: "./site-search-page.component.html",
    providers: [provideSearchModel(SiteSearchModel), provideEntityModel(SiteEntityModel)]
})

export class SiteSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
